import axios from 'axios';

export default {
    search: function (request) {
      return axios.get('/api/news/search', { params: request })
    },
    searchPublic: function (request) {
      return axios.get('/api/news/searchPublic', { params: request })
    },
    find: function (id) {
      return axios.get('/api/news/' + id)
    },
    save: function (data) {
      if (data.id && data.id > 0)
        return axios.put('/api/news/', data)
      else
        return axios.post('/api/news/', data)
    },    
    delete: function (id) {
      return axios.delete('/api/news/' + id)
    },
    getNewsStatuses: function() {
      return axios.get('/api/news/statuses')
    }
  }